import { Checkbox } from '@mui/material';
import { styled } from 'styled-components';
import pallet from '../../../layouts/pallet';

const StyledCheckbox = styled(Checkbox)`
  border-radius: 4px !important;
  color: ${pallet.formLabelText} !important;
  &.Mui-checked {
    color: ${pallet.formLabelText} !important;
  }
  &.MuiCheckbox-indeterminate {
    color: ${pallet.formLabelText} !important;
    }
  })
)`;

export default StyledCheckbox;
